import React, { Component } from 'react';
import Spinner from '../commonFiles/Spinner';
import AdminInfo from './AdminInfo';
class AdminApp extends Component {
  constructor() {
    super();
    this.state = {
    };
  }

componentDidMount(){

}


  render() {
    return (
        <div className="container-xxl bg-white p-0">
          <div className="container-fluid">
          <div className="row">
          <AdminInfo/>
          </div>
          </div>
          <Spinner/> 
        </div>
    );
  }
}

export default AdminApp;
